import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { ProductCard } from "./ProductCard";

const API_URL = "https://admin.bodiosyakdown.com/api";

export function CollectionPage() {
  const { category } = useParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProductsByCategory(category);
  }, [category]);

  const fetchProductsByCategory = async (category) => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/products`);
      const allProducts = res.data;

      const filtered = allProducts.filter(
        (product) =>
          product.category &&
          product.category.toLowerCase() === category.toLowerCase()
      );

      setProducts(filtered);
    } catch (err) {
      console.error("Failed to fetch products:", err);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  const categoryName = category
    ? category.charAt(0).toUpperCase() + category.slice(1)
    : "";
  const categoryDescription = category
    ? `Discover our collection of ${category} products.`
    : "";

  return (
    <div className="flex flex-col text-black pt-[145px] max-md:pt-[100px] max-w-[1672px] mx-auto">
      {/* Category Name */}
      <div className="self-center text-6xl text-center uppercase max-md:text-4xl">
        {categoryName}
      </div>

      {/* Description */}
      <section className="self-center font-libreFranklin mt-6 text-center w-full max-w-3xl px-4 text-lg">
        {categoryDescription}
      </section>

      {/* Filter header */}
      <div className="flex justify-between items-center bg-gray-100 p-4 rounded-lg w-full max-w-[1700px] mx-auto mt-10 px-6">
        <h3 className="font-semibold text-lg">Filter</h3>
        <span className="font-semibold text-md">{products.length} Products</span>
      </div>

      {/* Product Grid */}
      {loading ? (
        <p className="text-center mt-10">Loading...</p>
      ) : products.length === 0 ? (
        <p className="text-center mt-10 text-xl">
          No products found in this category.
        </p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 px-4 max-w-[1920px] mx-auto mt-8">
          {products.map((product) => (
            <ProductCard
              key={product.id}
              id={product.id}
              name={product.name}
              image={product.mainImage}
              price={product.min_price || product.price}
              stock={product.stock}
            />
          ))}
        </div>
      )}
    </div>
  );
}